import React from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Routes, Route } from "react-router-dom";

import PropTypes from "prop-types";

import { layoutTypes } from "./constants/layout";
import { authProtectedRoutes, publicRoutes } from "./routes";

import Authmiddleware from "./routes/route";

import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

import "./assets/scss/theme.scss";
import "react-toastify/dist/ReactToastify.css";

import fakeBackend from "./helpers/AuthType/fakeBackend";
fakeBackend();

// Layout switcher function
const getLayout = (layoutType) => {
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      return VerticalLayout;
    case layoutTypes.HORIZONTAL:
      return HorizontalLayout;
    default:
      return VerticalLayout;
  }
};

// Main App component
const App = () => {
  const LayoutSelector = createSelector(
    (state) => state.Layout,
    (layout) => ({ layoutType: layout.layoutType })
  );

  const { layoutType } = useSelector(LayoutSelector);
  const Layout = getLayout(layoutType);

  return (
    <React.Fragment>
      {/* Global notification */}
      {/* <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}

      <Routes>
        {/* Public routes - no auth, e.g., uses X-API-KEY */}
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <NonAuthLayout>
                {route.component}
              </NonAuthLayout>
            }
            key={`public-${idx}`}
          />
        ))}

        {/* Auth protected routes - requires JWT */}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Authmiddleware>
                <Layout>
                  {route.component}
                </Layout>
              </Authmiddleware>
            }
            key={`private-${idx}`}
          />
        ))}
      </Routes>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

export default App;
